export default __webpack_public_path__ + "static/media/promos-icon.51d1162d.webp";